export const messages = {
  en: {
    goodCashierConfirm: {
      scanTitle: 'Please scan the QR code',
      confirmTitle: 'Payment Confirmation',
      totalAmount: 'Total Amount',
      consumePoints: 'Consume Points',
      discountMethod: 'Discount Method',
      discountRate: 'Discount Rate',
      discountAmount: 'Discount Amount',
      receivableAmount: 'Receivable Amount',
      paymentInfo: 'Payment Info',
      paymentPlaceholder: 'Required, please enter payment info',
      actualAmount: 'Actual Amount',
      change: 'Change',
      close: 'Close',
      confirm: 'Confirm',
      selectDiscount: 'Select discount method',
      discount: 'Discount',
      reduction: 'Reduction'
    }
  },
  zh: {
    goodCashierConfirm: {
      scanTitle: '请用扫码枪扫码',
      confirmTitle: '结算确认',
      totalAmount: '总金额',
      consumePoints: '消费积分',
      discountMethod: '优惠方式',
      discountRate: '打折率',
      discountAmount: '减免金额',
      receivableAmount: '应收金额',
      paymentInfo: '支付信息',
      paymentPlaceholder: '必填，请填写支付信息',
      actualAmount: '实收金额',
      change: '找零',
      close: '关闭',
      confirm: '确定',
      selectDiscount: '请选择优惠方式',
      discount: '打折',
      reduction: '减免'
    }
  }
}